import { useContext, useMemo } from 'react';
import { BeefCoExtContext } from "../context";
export var useBeefCoExtSdk = function useBeefCoExtSdk() {
  var extSdk = useContext(BeefCoExtContext);
  if (!extSdk) throw new Error('Attempting to call useBeefCoExtStd before sdk initialization');
  return extSdk;
};
export var useBeefCoExtend = function useBeefCoExtend() {
  var _useBeefCoExtSdk = useBeefCoExtSdk(),
    originalExtendNode = _useBeefCoExtSdk.extendNode;
  return useMemo(function () {
    var extendedComponents = new WeakMap();
    return function (Component) {
      if (!originalExtendNode) return Component;
      if (!extendedComponents.has(Component)) {
        extendedComponents.set(Component, originalExtendNode(Component));
      }
      return extendedComponents.get(Component);
    };
  }, [originalExtendNode]);
};